import Lottie from "react-lottie"
import Logo from "../../assets/img/ManejeBemLogo.png"
import checkLottie from "../../assets/icons/check-lottie.json"
import "./styles.scss"
import { ModalPanel } from "../../components/Modal"

export const NpsScreen = ({
  saving,
  handle,
  onSave,
  marks,
  evaluation,
  Slider,
  creationState,
  description,
  closeCreationModal,
}) => {
  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: checkLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }

  if (creationState.success) {
    return (
      <div>
        <div className="training__card__container">
          <img src={Logo} />
          <div className="training__card__background">
            <Lottie options={defaultLottieOptions} height={300} width={300} />
            <p className="training__card__title">Sua avaliação foi enviada com sucesso!</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="training__card__container">
        <img src={Logo} />
        <div className="training__card__background">
          <div className="training__card__background--align">
            <p className="training__card__title">Confirme a realização do seu treinamento</p>
            <p className="training__card__desc">{description}</p>
            <div className="training__card__background--center">
              <p className="training__card__title__picker">Avalie o treinamento realizado</p>{" "}
              {/* Deixe sua nota! */}
              <div className="training__slider__container">
                <Slider
                  min={1}
                  dotStyle={{ display: "none" }}
                  max={10}
                  style={{ width: "95%", height: "100%", alignItems: "center", display: "flex" }}
                  trackStyle={
                    evaluation <= 5
                      ? {
                          height: 15,
                          backgroundImage: `linear-gradient(to right, rgba(255,255,255), rgba(244,183,64))`,
                        }
                      : {
                          height: 15,
                          backgroundImage: `linear-gradient(to right, rgba(255,255,255), rgba(122,196,87))`,
                        }
                  }
                  railStyle={{ height: 15, backgroundColor: "transparent" }}
                  handleStyle={{ width: 50, height: 50 }}
                  handle={(props) => handle(props)}
                  marks={marks}
                  defaultValue={10}
                />
              </div>
              <button onClick={onSave} className="training__button">
                <p className="training__button__text">
                  {"  "} {saving ? "Aguarde..." : "Confirmar que realizei o treinamento"}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <ModalPanel
        message={creationState.message}
        modalIsOpen={creationState.error}
        alertType={creationState.success ? "success" : null}
        closeModal={() => closeCreationModal()}
      />
    </div>
  )
}
